// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__20lQk","productName":"Table_productName__2WuRi"};